export const API_KEY = '796f81d5c7ffa9fafdcaf69361eb9b8e';
export const FOOTBALL_API_URL = 'https://v3.football.api-sports.io';
export const NBA_API_URL = 'https://v3.basketball.api-sports.io';
